import { Component, OnInit, ViewChild, QueryList, ElementRef, ViewChildren, AfterViewInit, ChangeDetectorRef, ViewRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormsModule, ReactiveFormsModule, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import * as Rx from 'rxjs';
import { Store } from '@ngrx/store';

// import { FormValidationsService, QuoteDataCaptureService, ModalScroll } from '../../../../shared';

@Component({
  selector: 'app-test-ui-component',
  templateUrl: './test-ui-component.html',
  styleUrls: ['./test-ui-component.scss']
})
export class TestUIComponent implements OnInit {

 

  constructor() {

  }

  ngOnInit() {
    

  }
  
}
